export { getProductServerAction } from 'next-flight-server-reference-proxy-loader?id=60148e8c0995043284bcc36e02e640b6780bdcedbd&name=getProductServerAction!'